// Mock tracked-programs data for development / offline / safeFetch===null fallback.
//
// Mirrors api_MockFounders. A brand-new user (and the no-backend case) has NO
// tracked programs, so the default mock is an EMPTY set — the service and the
// provider must resolve to a valid empty result, never a throw.

import type { APIResponse } from './MyFounderTypes';
import type { TrackedProgram } from './TrackedProgramTypes';

/** Default mock set: empty (a fresh user has tracked nothing). */
export const MOCK_TRACKED_PROGRAMS: TrackedProgram[] = [];

/**
 * Returns an empty tracked-programs response. Used when the backend is
 * unavailable (safeFetch returns null) so callers get a well-formed empty
 * list instead of an error.
 */
export const getMockTrackedPrograms = (): APIResponse<TrackedProgram[]> => ({
  success: true,
  data: [...MOCK_TRACKED_PROGRAMS],
  message: 'No tracked programs (backend not available)',
});
